import { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import moment from "moment";
// Constants
import { WEB_SERVICE_MIMS } from "../../../../config/constants";
// Components
import { EditButton, EditPrescriptionImg, EditPrescriptionText } from "./styles";
import Axios from "../../../../config/axios";
import Popup from "../../../popup";
import PrescriptionCanvas from "../prescriptionCanvas";
// Assets
import EditImg from "../../../../assets/icons/btn_edit_user_blue.svg";

const UpdatePrescription = ({
  prescribedDate,
  dateToPrescribe,
  setDateToPrescribe,
  prescribedProtocols,
  protocolsToPrescribe,
  setProtocolsToPrescribe,
  diagnosisObservation,
  diagnosisObservationToAdd,
  setDiagnosisObservationToAdd,
  setIsLoadingPrescriptions,
  rechargePrescriptions,
  setRechargePrescriptions,
}) => {
  const [isShowingUpdatePrescriptionForm, setIsShowingUpdatePrescriptionForm] = useState(false);

  const { patientId, software } = useParams();
  const [t] = useTranslation("global");

  const updatePrescription = (e) => {
    e.preventDefault();
    const isSomeProtocolMarked = protocolsToPrescribe.some((protocolToPrescribe) => protocolToPrescribe.hasOwnProperty("STARTING_DATE"));
    const today = moment().startOf("day").format("YYYY-MM-DD");
    const dateToCompare = moment(dateToPrescribe, "YYYY-MM-DD");
    if (isSomeProtocolMarked && dateToCompare.isBefore(today))
      return toast.error(t("diagnosisProtocols_alerts_selectCorrectDate"));

    const prescriptionsData = {
      prescriptions: protocolsToPrescribe,
      diagnosisObservation: diagnosisObservationToAdd,
    };

    Axios("post", `${WEB_SERVICE_MIMS}/prescriptions/diagnosis/add/${patientId}/${software}`, prescriptionsData)
      .then(({ data }) => {
        if (data.success) {
          toast.success(t("diagnosisProtocols_alerts_sessionUpdated"));
          setIsLoadingPrescriptions(true);
          setRechargePrescriptions(!rechargePrescriptions);
        } else {
          toast.error(t("sendDataErrorMessage"));
        }
      })
      .catch((error) => {
        toast.error(t("sendDataErrorMessage"));
        console.log("Add diagnosis prescription: ", error);
      });
  };

  const renderEditPrescriptionButton = () => {
    return (
      <EditButton onClick={() => setIsShowingUpdatePrescriptionForm(true)}>
        <EditPrescriptionImg src={EditImg} alt="ico-edit" />
        <EditPrescriptionText>{t("diagnosisProtocols_editDiagnosisSessionButton")}</EditPrescriptionText>
      </EditButton>
    );
  };

  const renderPrescriptionPopup = () => {
    return (
      <Popup isShowed={isShowingUpdatePrescriptionForm} setIsShowed={setIsShowingUpdatePrescriptionForm}>
        <PrescriptionCanvas
          title={t("diagnosisProtocols_titles_editDiagnosisSession")}
          isOnlyDisplayed={true}
          prescribedDate={prescribedDate}
          dateToPrescribe={dateToPrescribe}
          setDateToPrescribe={setDateToPrescribe}
          prescribedProtocols={prescribedProtocols}
          protocolsToPrescribe={protocolsToPrescribe}
          setProtocolsToPrescribe={setProtocolsToPrescribe}
          diagnosisObservation={diagnosisObservation}
          diagnosisObservationToAdd={diagnosisObservationToAdd}
          setDiagnosisObservationToAdd={setDiagnosisObservationToAdd}
          setIsShowingPrescriptionForm={setIsShowingUpdatePrescriptionForm}
          rechargePrescriptions={rechargePrescriptions}
          setRechargePrescriptions={setRechargePrescriptions}
          savePrescription={updatePrescription}
        />
      </Popup>
    );
  };

  return (
    <>
      {renderEditPrescriptionButton()}
      {renderPrescriptionPopup()}
    </>
  );
};

export default UpdatePrescription;
